<div class="row no-gutters">
  @if (offer?.holderName) {
    <div class="column col-xs-6 mt-1">
      <span class="ob1-capsule ob1-capsule-small ob1-capsule-context">{{ offer.holderName }}</span>
    </div>
  }
  @if (offer?.mobileNumber) {
    <div class="column col-xs-6 mt-1">
      <span class="ob1-capsule ob1-capsule-small ob1-capsule-context">
        <span class="icon icon-device-smart-phone" aria-hidden="true"></span> {{ offer.mobileNumber | phone }}</span
      >
    </div>
  }
  @if (offer?.publicLineNumber) {
    <div class="column col-xs-6 mt-1">
      <span class="ob1-capsule ob1-capsule-small ob1-capsule-context">
        <span class="icon icon-device-smart-phone" aria-hidden="true"></span>
        {{ offer.publicLineNumber | phone }}</span
      >
    </div>
  }
  @if (offer?.city) {
    <div class="column col-xs-6 mt-1">
      <span class="ob1-capsule ob1-capsule-small ob1-capsule-context">
        <span class="icon icon-home" aria-hidden="true"></span> {{ offer.city }}</span
      >
    </div>
  }
  @if (offer?.referenceId) {
    <div class="column col-xs-6 mt-1">
      <span class="ob1-capsule ob1-capsule-small ob1-capsule-context"
        >{{ 'dashboard.accountNumber' | translate }} {{ offer.referenceId }}</span
      >
    </div>
  }
</div>
